import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from 'AuthContext';
import { fetchWithAuth } from "utils/fetchWithAuth";

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const IS_DEV = process.env.REACT_APP_ENV === "DEV";
const API_URL = process.env.REACT_APP_API_URL;

function hmsToSeconds(timedeltaStr) {
  const parts = timedeltaStr.split(':').map(Number);
  return (parts[0] * 3600) + (parts[1] * 60) + parts[2];
}

function formatDuration(durationStr) {
  if (!durationStr) return "";
  if (durationStr.includes("day")) {
    const match = durationStr.match(/^(\d+) day/);
    if (match) return `${match[1]} jour${match[1] > 1 ? "s" : ""}`;
  }
  const [h, m, s] = durationStr.split(":").map(Number);
  if (h > 0) return `${h} h`;
  if (m > 0) return `${m} min`;
  return `${s} sec`;
}

function formatAge(seconds) {
  if (seconds == null) return '?';
  
  // Age is in seconds
  if (seconds < 60) return `${seconds}s`; 
  // Age is in minutes
  if (seconds < 3600) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}m${s.toString().padStart(2, "0")}s`;
  }
  // Age is in hours
  if (seconds < 86400) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h${m.toString().padStart(2, "0")}m`;
  }
  // Age is in days
  const days = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  return `${days}j${h.toString().padStart(2, "0")}h`;
}

function tokenInfoBar(info) {
  const rawTimestamp = localStorage.getItem('token_received_at');
  const tokenReceivedAt = rawTimestamp ? Number(rawTimestamp) : null;
  const ageSec = tokenReceivedAt
    ? Math.max(0, Math.floor((Date.now() - tokenReceivedAt) / 1000))
    : null;
  const maxLifetimeSec = hmsToSeconds(info.ACCESS_TOKEN_LIFETIME);
  return (
    <>
      TOKEN:
        {tokenReceivedAt
          ? (
            <>
              <b>{formatAge(ageSec)}</b> / <b>{formatDuration(info.REFRESH_TOKEN_LIFETIME)}</b>
            </>
          )
        : <b>N/A</b>
      }
      {' | '}
      REFRESH: every <b>{formatAge(maxLifetimeSec)}</b> |
      ENV: <b>{info.DJANGO_ENV}</b> |
      DEBUG: <b>{info.DEBUG ? "ON" : "OFF"}</b>
    </>
  )
}

export default function UserBanner() {
  const { user, role, loading, logout } = useContext(AuthContext);
  const [devInfo, setDevInfo] = useState(null);

  useEffect(() => {
    if (IS_DEV) {
      fetchWithAuth(`${API_URL}/api/app_dev_info/`)
        .then(r => r.json())
        .then(setDevInfo)
        .catch(() => setDevInfo(null));
    }
  }, []);

  if (loading) return null;

  return (
    <AppBar position="fixed" color="primary">
      {IS_DEV && devInfo ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            minHeight: 72,
            paddingLeft: 16,
            paddingRight: 16
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
            <Typography variant="h6" component="div">
               {user?.username ? (
                  <>
                    Connecté en tant que <b>{user.username}</b>
                    {IS_DEV && <> ({role})</>}
                  </>
                ) : (
                  <>Connecté</>
                )}
            </Typography>
            <span style={{ fontSize: 10, color: "#d1d1d1" }}>
              [ {tokenInfoBar(devInfo)} ]
            </span>
          </div>
          <Button color="inherit" onClick={logout}>
            Se déconnecter
          </Button>
        </div>
      ) : (
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {user?.username ? (
              <>
                Connecté en tant que <b>{user.username}</b>
                {IS_DEV && <> ({role})</>}
              </>
            ) : (
              <>Connecté</>
            )}
          </Typography>
          <Button color="inherit" onClick={logout}>
            Se déconnecter
          </Button>
        </Toolbar>
      )}
    </AppBar>
  );
}